<template>
  <div class="copyArea">
    <div>
      <span class="fs14 fwb el-icon-document-copy"></span>
      <span class="fs13 ml2">Copy from existing:</span>
    </div>
    <el-select
      v-model="copyFromExist"
      value-key="id"
      filterable
      clearable
      placeholder="-- Select an existing data to copy --"
      class="wdb100"
      @change="copyFromHandle"
    >
      <el-option v-for="item in options" :key="`copy-from-${item.id}`" :label="getLabel(item)" :value="item"></el-option>
    </el-select>
  </div>
</template>

<script>
import { getFormDataFromSource } from "@/utils";
export default {
  props: {
    dataForm: {
      type: Object,
      default: () => {},
    },
    // 选项
    options: {
      type: Array,
      default: () => [],
    },
    // label的生成函数（由父组件决定显示什么内容）
    labelFormatter: { type: Function, default: null },
  },
  data() {
    return {
      copyFromExist: null,
    };
  },
  methods: {
    // 动态设置label
    getLabel(item) {
      if (this.labelFormatter) {
        return this.labelFormatter(item);
      }
      // 默认回退逻辑，防止报错
      return item;
    },
    // 选中change
    copyFromHandle(originalData) {
      // 从数据源中获取表单(dataForm)需要的数据
      const newDataForm = getFormDataFromSource(originalData, this.dataForm);
      // 触发父组件中方法
      this.$emit("copyFromTrigger", originalData, newDataForm);
      // 重置选中项
      this.copyFromExist = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.copyArea {
  background: #f4fbff;
  border: 1px solid #c5e8f9;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;

  .el-select {
    flex: 1;
  }
}
</style>
